import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import * as _ from 'lodash';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'select-from-dual-list',
  templateUrl: './select-from-dual-list.component.html',
  styleUrls: ['./select-from-dual-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectFromDualListComponent implements OnInit {

  @Input() sourceHeader: string;
  @Input() targetHeader: string;

  @Input() source: any = [];
  @Input() target: any = [];

  @Input() value: string;
  @Input() showValue = false;

  @Input() width: string;
  @Input() bindLabel = 'name';
  @Input() bindValue = 'id';

  @Output() targetChange = new EventEmitter();

  closeEventName = 'closeSelectDualListDropDown';

  innerTargetList: any = [];
  innerSourceList: any = [];

  displayedColumns: Array<any>;
  showDropDown = false;

  sourceSubset = new SelectionModel<any>(true, []);
  targetSubset = new SelectionModel<any>(true, []);

  header = '';

  constructor() {}

  ngOnInit(): void {
    this.displayedColumns = [this.bindLabel];
    this.initializeLists();
  }

  initializeLists(): void {
    this.innerSourceList = new MatTableDataSource<any>(this.source);
    this.innerTargetList = new MatTableDataSource<any>(this.value ? [] : this.target);
    this.generateHeader();
  }

  generateHeader(): void {
    if (!!this.value) {
      this.header = this.value;
    } else {
      this.header = this.innerTargetList.data.map((item) => item[this.bindLabel]).join(', ');
    }
  }

  hasItemsToAdd(): boolean {
    return this.sourceSubset.selected.length > 0;
  }

  hasItemsToRemove(): boolean {
    return this.targetSubset.selected.length > 0;
  }

  isUpAvailable(): boolean {
    return this.isValid(this.targetSubset.selected) && this.notFirst(this.targetSubset.selected);
  }

  isDownAvailable(): boolean {
    return this.isValid(this.targetSubset.selected) && this.notLast(this.targetSubset.selected);
  }

  onSelectFromSource(servers): void {
    if (this.sourceSubset.selected.indexOf(servers) === -1) {
      this.sourceSubset.select(servers);
    } else {
      this.sourceSubset.deselect(servers);
    }
  }

  onSelectFromTarget(servers): void {
    if (this.targetSubset.selected.indexOf(servers) === -1) {
      this.targetSubset.select(servers);
    } else {
      this.targetSubset.deselect(servers);
    }
  }

  addToTarget(): void {
    this.innerTargetList = new MatTableDataSource(this.innerTargetList.data.concat(this.sourceSubset.selected));
    this.innerSourceList = new MatTableDataSource(this.innerSourceList.data.filter((server) => {
      return this.sourceSubset.selected.filter((serverSubset) => {
        return serverSubset[this.bindValue] === server[this.bindValue];
      }).length === 0;
    }));
    this.refreshLists();
  }

  removeFromTarget(): void {
    this.innerSourceList = new MatTableDataSource(this.innerSourceList.data.concat(this.targetSubset.selected));
    this.innerTargetList = new MatTableDataSource(this.innerTargetList.data.filter((server) => {
      return this.targetSubset.selected.filter((serverSubset) => {
        return serverSubset[this.bindValue] === server[this.bindValue];
      }).length === 0;
    }));
    this.refreshLists();
  }

  moveUp(): void {
    if (this.isValid(this.targetSubset.selected)) {
      const selectedIndex = this.indexOfById(this.innerTargetList.data, this.targetSubset.selected[0]);
      const tempItem = this.innerTargetList.data[selectedIndex - 1];

      this.innerTargetList.data[selectedIndex - 1] = this.targetSubset.selected[0];
      this.innerTargetList.data[selectedIndex] = tempItem;
      this.innerTargetList = new MatTableDataSource(this.innerTargetList.data);
    }
  }

  moveDown(): void {
    if (this.isValid(this.targetSubset.selected)) {
      const selectedIndex = this.indexOfById(this.innerTargetList.data, this.targetSubset.selected[0]);

      const tempItem = this.innerTargetList.data[selectedIndex + 1];
      this.innerTargetList.data[selectedIndex + 1] = this.targetSubset.selected[0];
      this.innerTargetList.data[selectedIndex] = tempItem;
      this.innerTargetList = new MatTableDataSource(this.innerTargetList.data);
    }
  }

  refreshLists(): void {
    this.targetSubset.clear();
    this.sourceSubset.clear();
  }

  isValid(value): boolean {
    return _.isArray(value) && value.length > 0;
  }

  notFirst(value): boolean {
    return this.indexOfById(this.innerTargetList.data, value[0]) > 0;
  }

  notLast(value): boolean {
    return this.indexOfById(this.innerTargetList.data, value[0]) < this.innerTargetList.data.length - 1;
  }

  indexOfById(dataArray, selectedItem): number {
    const itemsCount = dataArray.length;

    for (let i = 0; i < itemsCount; i++) {
      if (_.isEqual(dataArray[i], selectedItem)) {
        return i;
      }
    }
    return -1;
  }

  isSelectedInSource(routingServer): boolean {
    return this.sourceSubset.selected.indexOf(routingServer) !== -1;
  }

  isSelectedInTarget(routingServer): boolean {
    return this.targetSubset.selected.indexOf(routingServer) !== -1;
  }

  setDropdownArrow(open): void {
    if (open) {
      this.showDropDown = true;
    } else {
      this.showDropDown = false;
    }
  }

  removeSelectedItems(event): void {
    this.value = null;
    event.stopPropagation();
    this.moveItemsFromTargetToSource();
    this.generateHeader();
    this.targetChange.emit(this.innerTargetList.data);
  }

  isTargetEmpty(): boolean {
    return this.innerTargetList.data.length === 0 && !this.value;
  }

  onApply(): void {
    this.generateHeader();
    if (this.value) {
      this.innerTargetList.data = [];
      this.innerTargetList.data.push(this.value);
    }
    this.targetChange.emit(this.innerTargetList.data);
    // this.sharedEventService.broadcast(this.closeEventName);
  }

  onCancel(): void {
    this.moveItemsFromTargetToSource();
    this.generateHeader();
    this.targetChange.emit(this.innerTargetList.data);
    // this.sharedEventService.broadcast(this.closeEventName);
  }

  moveItemsFromTargetToSource(): void {
    this.innerSourceList = new MatTableDataSource(this.innerSourceList.data.concat(this.innerTargetList.data));
    this.innerTargetList.data = [];
  }
}
